import { IconDefinition } from '@fortawesome/fontawesome-common-types/index'
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome'
import { Modify } from '@teinor/erp'
import TwinToolTip from '../TwinToolTip'
import { PlacesType, PositionStrategy } from 'react-tooltip'

export type TwinIconProp = IconDefinition

type TwinIconProps = Modify<FontAwesomeIconProps, {
    icon: TwinIconProp
}>

const TwinIcon: React.FC<TwinIconProps> = ({ icon, ...rest }) => {
    if (!icon) {
        return null
    }
    return (
        <FontAwesomeIcon icon={icon as any} {...rest} />
    )
}

export interface TwinIconToolTipProps {
    message: string
    id: string
    children?: React.ReactNode
    icon?: TwinIconProp
    classNameIcon?: string
    classNameTooltip?: string
    onClick?: (e: any) => void
    className?: string
    subRef?: any
    positionStrategy?: PositionStrategy
    place?: PlacesType
}

export const TwinIconToolTip: React.FC<TwinIconToolTipProps> = ({ message, id, children, icon, onClick, classNameIcon, className, subRef, positionStrategy, classNameTooltip, place = 'top' }) => {
    return (
        <div ref={subRef} className={'relative ' + (className || '')}>
            <TwinToolTip id={id} place={place} content={message} positionStrategy={positionStrategy} className={classNameTooltip} />
            <div>
                {children}
                {icon ? <TwinIcon data-tooltip-id={id} className={'cursor-pointer px-1 ' + (classNameIcon || '')} icon={icon} onClick={onClick} /> : null}
            </div>
        </div>
    )
}


export default TwinIcon